import { formatNumberWithAbbreviation } from "@memorang/helpers/common";
import { Trans } from "react-i18next";
import type { StyleProp, TextStyle } from "react-native";
import { Text } from "react-native-paper";
import Box from "../Box";

type Props = {
	value: number;
	i18nKey?: string;
	numberStyle?: StyleProp<TextStyle>;
	unitStyle?: StyleProp<TextStyle>;
	unitVariant?: React.ComponentProps<typeof Text>["variant"];
};

export const LeaderboardXpAmount = ({
	value,
	i18nKey = "leaderboard.xpAmount",
	numberStyle,
	unitStyle,
	unitVariant = "bodySmall",
}: Props) => {
	return (
		<Box flexDirection="row" alignItems="flex-end" gap={4}>
			<Text>
				<Trans
					i18nKey={i18nKey}
					values={{ value: formatNumberWithAbbreviation(value) }}
					components={{
						num: <Text style={numberStyle}>{""}</Text>,
						unit: (
							<Text variant={unitVariant} style={unitStyle}>
								{""}
							</Text>
						),
					}}
				/>
			</Text>
		</Box>
	);
};
